<template>
  <section class="section container pt-0">
    <records-datatable />
  </section>
</template>

<script>
import RecordsDatatable from "./records_datatable/Index.vue";

export default {
  name: "LittleJarIndex",
  components: {
    RecordsDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
